import React from 'react';
import { NoSymbolIcon } from '@heroicons/react/24/solid';

interface Props {
  url?: string;
}

const iframeStyles: React.CSSProperties = {
  // Targeted height 250px
  height: 575,
  width: '250%',
  WebkitTransform: 'scale(0.4)',
  WebkitTransformOrigin: '0 0',
  transformOrigin: '0 0',
  transform: 'scale(0.4)',
  pointerEvents: 'none',
};

export const SnapshotPreview: React.FC<Props> = (props) => {
  const { url } = props;

  if (!url)
    return (
      <div className="gap-2 text-gray-400 flex flex-col items-center justify-center h-[250px]">
        <NoSymbolIcon className="h-7" />
        <h3>Not available</h3>
      </div>
    );

  return url.includes('png') || url.includes('jpg') ? (
    <img src={url} alt={url} width="100%" className="object-contain" />
  ) : (
    <iframe title={url} src={url} style={iframeStyles} />
  );
};
SnapshotPreview.displayName = 'TerminalScreenshots.SnapshotPreview';
